// Navigation configuration for Layout.jsx — extracted 2026-07-15 (refactor/layout-nav-extract).
// Pure data: page titles for the topbar, RBAC role display metadata, and the
// left-sidebar navigation registry per role/section. No hooks, no side effects.
// Moved verbatim out of Layout.jsx (no content changes) to shrink the god-component
// and let new-module registration (CLAUDE.md §3) touch a small config file instead
// of a 1600+ line component.
import {
    Activity, AlarmClock, AlertTriangle, BadgeCheck, BarChart3, BookOpen, Bot, Brain,
    Briefcase, Building2, Calendar, CalendarClock, CalendarDays, ClipboardCheck,
    ClipboardList, Clock, Code2, Coins, Compass, Crosshair, Crown, Euro, Eye, FileCheck,
    FileSignature, FileText, Flag, FlaskConical, FolderKanban, Gauge, Gift, GitBranch, GraduationCap, Grid3x3, Handshake,
    Headphones, Heart, HeartHandshake, History, Inbox, Key, Laptop, Layers,
    LayoutDashboard, LifeBuoy, Link2, ListChecks, ListTodo, MapPin, MessageCircle, Mic, Monitor,
    Network,
    Package, Palette, PenLine, PieChart, Plug, Presentation, Ruler, Search, Settings,
    Shield, ShieldCheck, ShoppingCart, Sparkles, Star, Store, Sunrise, Target, Telescope, TrendingUp, Trophy,
    Upload, User, UserCheck, UserMinus, UserPlus, Users, UsersRound, Wallet, Zap,
} from 'lucide-react'
import { ALL_GROUP_TABS } from './navGroups'
import { SETTINGS_GROUPS } from './SettingsMenu'

export const TYPE_LABELS = { employee: 'Сотрудник', candidate: 'Кандидат', vacancy: 'Вакансия', page: 'Раздел ERP' }

// Page titles for topbar
export const PAGE_TITLES = {
    '': 'Дашборд',
    // Маршрут /dashboard (HomeRedirect forceDashboard) без своего ключа
    // выводил «Dashboard» — заголовок собирался из сегмента пути.
    'dashboard': 'Дашборд',
    'pipeline': 'Воронка',
    'candidates': 'Кандидаты',
    'vacancies': 'Вакансии',
    'requisitions': 'Заявки на подбор',
    'tests': 'Тесты',
    'job-profiles': 'Профили должностей',
    'offers': 'Офферы',
    'process': 'Бизнес-процесс',
    'analytics': 'Аналитика рынка',
    'cabinet': 'Мой профиль',
    'start': 'Стартовый центр',
    'home': 'Главная',
    'support': 'Поддержка',
    'support/answers': 'База ответов',
    'support-board': 'Поддержка · Пульт',
    'wiki': 'База знаний',
    'teambuilder': 'Team Builder',
    'projects': 'Проекты',
    'workflows': 'Workflow Studio',
    'workflow': 'Бизнес-процессы',
    // 'workflow/my-tasks' удалён в PR-H — редирект на /inbox?tab=workflow
    'workflow/runs': 'Workflow Run',
    'employees': 'Сотрудники',
    'personnel-file': 'Личное дело',
    'timesheet': 'Табель',
    'documents': 'Визы и документы',
    'orgchart': 'Оргструктура',
    'itadmin': 'IT-панель',
    'timeoff': 'Отпуска',
    'assets': 'Оборудование',
    'keys': 'Ключи',
    'inventory-visibility': 'Видимость оборудования',
    'benefits': 'Льготы и бонусы',
    'calendar': 'Календарь',
    'executive': 'Аналитика руководителя',
    'myteam': 'Моя команда',
    'dept-dashboard': 'Дашборд подразделения',
    'team-timesheet': 'Табель команды',
    'work-schedules': 'Графики работ',
    'team-payments': 'Ведомость',
    'payment-tasks': 'Задачи выплат',
    'team/learning': 'Обучение команды',
    'training': 'Управление обучением',
    'me/learning': 'Моё обучение',
    'me/learning/voice': 'Голос — английский',
    'me/skill-profile': 'Профиль навыков',
    'me/payslip': 'Моя зарплата',
    'growth-me': 'Моё развитие',
    'growth-team': 'Развитие команды',
    'growth-kb': 'Мои артефакты знаний',
    'growth-analytics': 'Аналитика развития',
    'ceo': 'Стратегия и KPI',
    'exchange': 'Exchange Dashboard',
    'senate-ops-dashboard': 'Senate Ops Dashboard',
    'stale-orders': 'Зависшие заявки',
    'marketing': 'Маркетинг',
    // Detail-страница одного канала: в меню её нет, но заголовок топбару нужен.
    'marketing/channels': 'Канал привлечения',
    'ps2-bot': 'PS2 Bot',
    'ps2-bot/review': 'Review Studio',
    'flags': 'Feature Flags',
    'legal-templates': 'Шаблоны документов',
    'rbac': 'Управление доступами',
    'workflow-history': 'История процессов',
    'hh-settings': 'HH.ru API настройки',
    'hh-responses': 'Отклики HH.ru',
    'hh-search': 'Поиск резюме HH.ru',
    'hh-messenger': 'Переписка HH.ru',
    'hh-vacancy-stats': 'Статистика вакансий HH',
    'signing': 'Документы на подпись',
    'resume-scraper': 'Суперкнопка — импорт резюме',
    'contractors': 'Подрядчики',
    'contractor-cabinet': 'Кабинет подрядчика',
    'department-contractor-tasks': 'Задачи подрядчикам',
    'ad-budget': 'Пополнения рекламы',
    'okr': 'Цели и OKR',
    'operating-model': 'Операционная модель — диагностика',
    'spans-of-control': 'Норма управляемости',
    'skills-footprint': 'Карта компетенций',
    'behaviors': 'Поведенческие паттерны',
    'quarterly-governance': 'Квартальный обзор OKR',
    'partners': 'Партнёры (экосистема)',
    'partner-home': 'Партнёрка',
    'partner-desk': 'Мой рабочий стол',
    'partner-team-compare': 'Я и команда',
    'partner-team': 'Команда партнёрки',
    'partner-crm': 'Партнёры (CRM)',
    'partner-network-tree': 'Дерево сети',
    'partner-crm/deletion-requests': 'Заявки на удаление партнёров',
    'partner-crm/merge-requests': 'Заявки на слияние партнёров',
    'partner-crm/touch-duplicates': 'Разбор дублей дел',
    'partner-crm/geo-leads': 'Гео-лиды (парсер с карт)',
    'partner-finance': 'Оборот и маржа',
    'partner-search': 'Поиск в CRM',
    'partner-products': 'Продукты',
    'partner-plans': 'Планы по партнёрам',
    'partner-analytics': 'Аналитика партнёров',
    'partner-analytics-suite': 'Аналитика',
    'partner-import': 'Импорт партнёров',
    'partner-meetings': 'Журнал встреч',
    'partner-meetings-dashboard': 'Дашборд встреч',
    'partner-funnel-stats': 'Воронка: статистика',
    'partner-touch-plan': 'План дел на неделю',
    'partner-plan-gap': 'План месяца',
    'partner-tasks': 'Дела',
    'partner-exec': 'Партнёрка: стратегия',
    'okk': 'ОКК — Контроль качества',
    'okm': 'ОКМ — Отчёт по ключевым метрикам',
    'owner-panel': 'Панель собственника',
    'partner-docs-marketing': 'Маркетинговые материалы',
    'partner-docs-marketing/new': 'Добавить материал',
    'partner-docs-contracts': 'Шаблоны договоров',
    'partner-docs-contracts/new-template': 'Новый шаблон',
    'partner-docs-contracts/from-template': 'Создать из шаблона',
    'partner-sla-admin': 'SLA-правила',
    'partner-segments-admin': 'Критерии сегментов',
    'kudos': 'Kudos — Признание',
    'people-analytics': 'People Analytics',
    'inbox': 'Мой Inbox',
    'rewards': 'Магазин наград',
    'internal-jobs': 'Карьера внутри компании',
    'referrals': 'Реферальная программа',
    'reviews': 'Performance Reviews',
    'hr-lifecycle': 'HR Lifecycle Dashboard',
    'onboarding-dashboard': 'Эффективность онбординга',
    'offboardings': 'Оффбординги',
    'knowledge': 'База знаний AI',
    'ai-studio': 'AI Studio',
    'admin-modules': 'Module Store',
    'admin-organizations': 'Организации',
    'admin/cold-start': 'Cold-start: tenant legal playbook',
    'admin/watchers': 'Watchers (named-агенты автоматизаций)',
    'admin/claude-plugins': 'Claude Code — установленные плагины',
    'admin/ai-drafts': 'AI-черновики — подтверждение AI-выходов',
    'admin/dsar': 'Запросы данных сотрудника (DSAR)',
    'admin/termination-reviews': 'AI-проверка планируемых увольнений',
    'admin/security': 'Дашборд безопасности',
    'admin/compliance-overview': 'AML Compliance Overview',
    'business-processes': 'Бизнес-процессы',
    'style-guide': 'Design System',
    'api-docs': 'API Reference',
    'offer-approvals': 'Согласование офферов',
    'integrations': 'Integration Hub',
    'headcount-planning': 'Headcount Planning',
    'expenses': 'Корпоративные расходы',
    'expense-approvals': 'Согласование расходов',
    'finance-articles': 'Финансовые справочники',
    'finance-journal-import': 'Загрузка журнала',
    'finance-office-payback': 'Окупаемость точек',
    'finance-operations': 'Финансовые операции',
    'finance-fx-rates': 'Курсы валют',
    'finance-purchases': 'Закупки',
    'finance-allocation-queue': 'Очередь разнесения',
    'finance-analytics': 'Финансовая аналитика',
    'shortlist': 'Шортлист',
    'talent-pool': 'Кадровый резерв',
    'system-costs': 'Стоимость обслуживания',
    'mission-control': 'Mission Control',
    'agent-tasks': 'Задачи агента',
    'ai-watch': 'AI Watch — дайджесты',
    'sandbox': 'Песочница',
    'my-colleagues': 'Мои коллеги',
    'my-track': 'Мой адаптационный трек',
    'onboarding-paths': 'Треки адаптации',
    'manager-dashboard': 'Мой дашборд',
    'manager-team': 'Команда менеджеров',
    'kpi-targets': 'KPI-планы',
    'team-test-results': 'Результаты тестов команды',
    'team-insights/trainer-vs-real': 'Калибровка тренажёра',
    'team-insights/readiness': 'Готовность команды',
    'me/morning-debrief': 'Вчерашний разбор',
    // 'messenger' route удалён 2026-05-24 — мессенджер только через AssistantsMenu.
    'dialogue-trainer': 'Диалог-тренажёр',
    // Дополнено 2026-05-23: недостающие маршруты, чтобы шапка не выводила
    // ничего невнятного. fix #1064 убрал fallback к «Дашборд», теперь у этих
    // страниц явные русские названия.
    'careers': 'Карьерные вакансии',
    'offboarding/handover': 'Передача дел при увольнении',
    'personas': 'Библиотека персон',
    'quality': 'Quality Dashboard',
    'repetition': 'Spaced Repetition',
    'review': 'Performance Review',
    'simulator': 'Симулятор',
    'wiki-test': 'Тест по статье Wiki',
    'learning-manager': 'Compliance-дашборд обучения',
    'learning-paths': 'Траектории обучения',
    'track-outcomes': 'Исходы треков',
}

// ══ RBAC Role definitions ═══════════════════════════════════
// Все реальные роли системы (паритет с backend/app/services/rbac_metadata.py ROLES).
// «custom» намеренно не включён: его набор модулей задаётся per-user, а не выводится из роли,
// поэтому в превью «Просмотр как роль» он ничего осмысленного не покажет.
export const ROLES = {
    admin: { label: 'Администратор', Icon: Shield, color: 'var(--color-accent)' },
    owner: { label: 'Собственник', Icon: Crown, color: 'var(--color-accent)' },
    ceo: { label: 'CEO', Icon: Trophy, color: 'var(--color-accent)' },
    hr: { label: 'HR-лид', Icon: Users, color: 'var(--color-success)' },
    recruiter: { label: 'HR Рекрутер', Icon: UserPlus, color: 'var(--color-success)' },
    dept_head: { label: 'Руководитель отдела', Icon: ClipboardList, color: 'var(--color-warning)' },
    deputy_head: { label: 'Заместитель руководителя отдела', Icon: ClipboardCheck, color: 'var(--color-warning)' },
    head: { label: 'Руководитель (legacy)', Icon: ClipboardList, color: 'var(--color-warning)' },
    it: { label: 'IT-администратор', Icon: Monitor, color: 'var(--color-info)' },
    cmo: { label: 'Директор по маркетингу (CMO)', Icon: TrendingUp, color: 'var(--color-accent)' },
    finance: { label: 'Финансы', Icon: Euro, color: 'var(--color-info)' },
    senior_online_manager: { label: 'Старший онлайн-менеджер', Icon: Headphones, color: 'var(--color-info)' },
    online_manager: { label: 'Онлайн-менеджер', Icon: Headphones, color: 'var(--color-info)' },
    head_of_partners: { label: 'Руководитель партнёрской команды', Icon: Handshake, color: 'var(--color-info)' },
    deputy_head_of_partners: { label: 'Заместитель руководителя партнёрской команды', Icon: Handshake, color: 'var(--color-info)' },
    partner_manager: { label: 'Менеджер по работе с партнёрами', Icon: Handshake, color: 'var(--color-info)' },
    okk_specialist: { label: 'Специалист ОКК', Icon: ShieldCheck, color: 'var(--color-accent)' },
    office_manager: { label: 'Офис-менеджер', Icon: Building2, color: 'var(--color-info)' },
    payer: { label: 'Плательщик', Icon: Euro, color: 'var(--color-info)' },
    zam: { label: 'Заместитель', Icon: ClipboardCheck, color: 'var(--color-warning)' },
    methodologist: { label: 'Методолог', Icon: Ruler, color: 'var(--color-danger)' },
    business_assistant: { label: 'Бизнес-ассистент', Icon: Briefcase, color: 'var(--color-accent)' },
    assistant: { label: 'Ассистент руководителя (legacy)', Icon: Briefcase, color: 'var(--color-accent)' },
    consultant: { label: 'Консультант (внешний)', Icon: GraduationCap, color: 'var(--color-accent)' },
    // Без этой строки подпись роли падала в fallback и подрядчик читался как
    // рядовой сотрудник (жалоба 2026-07-28). Подпись синхронна бэкенду —
    // app/services/rbac_metadata.py::"marketing_contractor".
    marketing_contractor: { label: 'Подрядчик', Icon: Briefcase, color: 'var(--color-info)' },
    employee: { label: 'Сотрудник', Icon: User, color: 'var(--color-success)' },
}

// ══ Navigation items (no hardcoded roles — access controlled by backend allowed_modules) ══
// M-2: порядок по частоте использования — самые частые разделы сверху, HH-группа снизу
// Рекрутинг: 18 пунктов → 6 (docs/specs/navigation-redesign-2026-07.md).
// «Суперкнопка» не дублируется — она живёт во вкладке «Наём и адаптация».
export const NAV_RECRUITING = [
    { to: '', icon: LayoutDashboard, label: 'Дашборд', end: true },
    { groupKey: 'candidates' },        // Все кандидаты · Воронка · Шортлист · Резерв
    { groupKey: 'vacancies' },         // Вакансии · Заявки · Профили должностей
    { groupKey: 'offers' },            // Офферы · Документы на подпись
    { to: 'tests', icon: FileCheck, label: 'Тесты' },
    { groupKey: 'hh' },                // Отклики · Поиск · Переписка · Статистика
    { groupKey: 'hiring-analytics' },  // Аналитика рынка · Бизнес-процесс
]

// Личный кабинет: 20 пунктов → 4-5 (docs/specs/navigation-redesign-2026-07.md §1).
// Близкие разделы свёрнуты в группы (см. navGroups.js) — маршруты не изменились,
// поменялась только точка входа. «Мой профиль» (cabinet) живёт в аккаунт-меню под
// аватаркой (2026-06-18) — личность/настройки там, а не в рабочей навигации.
// Отключены до настройки процесса: «Мои расходы» (expenses) и «Голос — английский»
// (me/learning/voice) — модули оставлены за ролью admin в module_seed.
// Мессенджер — только через топбарный AssistantsMenu (2026-05-24).
export const NAV_PERSONAL = [
    // «Моя зарплата» — self-service расчётный лист, non-removable personal surface
    // (MUST_HAVE_CORE='me/payslip'). Виден всем built-in ролям, scope по себе.
    { to: 'me/payslip', icon: Wallet, label: 'Моя зарплата' },
    // Мои курсы · Развитие · Тренажёр · Навыки · Мои материалы
    { groupKey: 'learning' },
    // «Мой адаптационный трек» переехал сюда из секции «Онлайн-менеджер»
    // (2026-08-21): трек адаптации есть у партнёр-менеджера и у любого другого
    // отдела, а в чужой секции его видел только онлайн-менеджер. Показывается
    // по факту записи на трек, не по роли — фильтр в useMyTrackNav.
    { to: 'my-track', icon: GraduationCap, label: 'Мой адаптационный трек', moduleKey: 'my-track' },
    { to: 'wiki', icon: BookOpen, label: 'База знаний' },
    // Проекты (P3.express). Пункт видят и участники проектов, не только
    // руководители: карточка показывает, кто и к какому сроку что делает.
    // Заведение проекта закрыто правом `projects.create`, раздел целиком —
    // рубильником `projects`.
    { to: 'projects', icon: FolderKanban, label: 'Проекты', moduleKey: 'projects' },
    // Мои задачи · Поддержка · Льготы · Карьера внутри · Рекомендую друга · Награды
    { groupKey: 'my-services' },
    // AI Studio · Team Builder · Workflow Studio — power-user инструменты,
    // рядовой сотрудник их не видит (allowed_roles в module_seed).
    { groupKey: 'tools' },
]

// Подрядчик (marketing_contractor) — ЗАМЕНА NAV_PERSONAL, не дополнение.
// 2026-07-28: у подрядчика вообще не было пункта меню на свой кабинет —
// `contractor-cabinet` жил только в HomeRedirect, т.е. открывался один раз при
// входе и терялся навсегда после первого клика по любому другому разделу.
// Подрядчик Антохин так и не нашёл свои реквизиты («Финансов нет»), потому что
// «Личный кабинет» подсовывал ему «Мою зарплату» — employee-расчётный лист,
// которого у подрядчика не существует (MUST_HAVE_CORE отдаёт me/payslip всем
// built-in ролям). Здесь — узкий набор поверхностей, которые у подрядчика
// реально есть: свой кабинет (профиль · реквизиты · суммы · аналитика),
// задачи и база знаний.
export const NAV_CONTRACTOR = [
    { to: 'contractor-cabinet', icon: Briefcase, label: 'Мой кабинет' },
    { to: 'inbox', icon: Inbox, label: 'Мои задачи' },
    { to: 'wiki', icon: BookOpen, label: 'База знаний' },
]

// HR: 22 пункта → 7 (docs/specs/navigation-redesign-2026-07.md §2).
// Ушли из HR: «Оборудование и ключи» (NAV_OFFICE), «Подрядчики» и «Пополнения
// рекламы» (NAV_MARKETING), «Видимость оборудования» (администрирование),
// «Партнёры» (раздел был пуст — удалён), «Расписание смен» (дублировало
// «Графики работ» — удалено).
export const NAV_HR = [
    { groupKey: 'people' },          // Список · Оргструктура
    // Подрядчики — такие же личные дела, только для внешних исполнителей:
    // договор, реквизиты, задачи, начисления, доступ в кабинет. Раздел и
    // карточка существовали с самого начала, но в меню не значились, и попасть
    // в них можно было только по прямой ссылке.
    { to: 'contractors', icon: Briefcase, label: 'Подрядчики' },
    { to: 'timesheet', icon: Clock, label: 'Табель' },
    { groupKey: 'absences' },        // Отпуска · Календарь команды
    { to: 'documents', icon: FileText, label: 'Визы и документы' },
    { groupKey: 'hiring' },          // Суперкнопка · Жизненный цикл · Онбординг · Оффбординги
    { groupKey: 'growth-review' },   // Развитие команды · Ревью · Цели · Благодарности · Аналитика
    // Бывш. «Обучение и развитие» — рабочее место методолога/HR, не личный кабинет.
    { to: 'training', icon: GraduationCap, label: 'Управление обучением' },
]

// Разделы, которые к HR не относятся (docs/specs/navigation-redesign-2026-07.md §3):
//   «Маркетинг» — обзор + подрядчики + пополнения рекламы; смотрят директор по
//     маркетингу и ассистент руководителя;
//   «Оборудование и ключи» — администраторы офисов, Васкевич, Кейзеров.
// Держим их одной секцией, чтобы над единственным пунктом не стоял заголовок
// с тем же словом («Маркетинг» над «Маркетингом»).
export const NAV_OPERATIONS = [
    { groupKey: 'marketing' },
    { groupKey: 'equipment' },
]

// Финансы. Своя секция, а не пункт внутри «Личного кабинета»: расходы — это
// деньги компании, а не личный сервис сотрудника. До 2026-08-10 «Расходы» были
// спрятаны из меню целиком (allowed_roles=["admin"], см. module_seed) — экран
// работал, но найти его можно было только поиском, из-за чего дефекты в нём
// жили месяцами.
//
// Секция задумана как точка роста финансового контура (эпик F-01…F-13): сюда
// же придут платёжный календарь и бюджеты. Операции и аналитика уже подключены
// отдельными рабочими страницами; старые расходы остаются доступны до cutover.
//
// Видимость каждой строки гейтится isModuleVisible: сотрудник видит свои
// заявки, финансы и согласующие — ещё и очередь на одобрение.
export const NAV_FINANCE = [
    // Заливка журнала управленческого учёта (F-13): владелец грузит файл сам и
    // видит контрольные суммы по валютам ДО того, как партия уйдёт в учёт.
    { to: 'finance-journal-import', icon: Upload, label: 'Загрузка журнала' },
    // Окупаемость точек (F-13): выручка, расходы, аренда отдельной строкой и
    // результат по каждой точке — плюс сценарий «а если статья вырастет».
    { to: 'finance-office-payback', icon: Store, label: 'Окупаемость точек' },
    { to: 'finance-operations', icon: ClipboardList, label: 'Операции' },
    // Закупки FIN CORE (S4): черновик, одобрение вторым человеком с резервом бюджета.
    { to: 'finance-purchases', icon: ShoppingCart, label: 'Закупки' },
    { to: 'finance-allocation-queue', icon: ListChecks, label: 'Очередь разнесения' },
    { to: 'finance-analytics', icon: PieChart, label: 'Аналитика' },
    // Реестр котировок (ADR-078): курс на дату заводится руками и подтверждается
    // вторым человеком. Живёт под тем же рубильником, что и остальные операции.
    { to: 'finance-fx-rates', icon: Coins, label: 'Курсы' },
    // Справочник статей управленческого учёта (F-12): смысл строки отчётности,
    // отдельно от политики расхода, которая осталась в категориях.
    { to: 'finance-articles', icon: BookOpen, label: 'Финансовые справочники' },
    { to: 'expenses', icon: Wallet, label: 'Расходы' },
    { to: 'expense-approvals', icon: BadgeCheck, label: 'Согласование расходов' },
]

// Approvals (offer) — секция согласований. «Согласование расходов» переехало
// отсюда в NAV_FINANCE: держать его рядом с самими расходами понятнее, чем
// рядом с офферами, а дублировать один пункт в двух секциях нельзя — меню
// показало бы его дважды.
export const NAV_APPROVALS = [
    { to: 'offer-approvals', icon: BadgeCheck, label: 'Согласование офферов' },
]

// Руководитель подразделения: 11 пунктов → 5.
export const NAV_DEPT_HEAD = [
    { groupKey: 'dept-team' },      // Люди · Дашборд подразделения
    { groupKey: 'team-learning' },  // Прогресс · Тесты · Калибровка · Готовность
    { groupKey: 'team-time' },      // Табель команды · Графики работ
    { groupKey: 'team-money' },     // Ведомость · Задачи выплат
    // Подрядчики отдела — внешние исполнители, которых руководитель не видит в
    // «Люди»: у них нет карточки сотрудника.
    { to: 'department-contractor-tasks', icon: ClipboardList, label: 'Задачи подрядчикам' },
    { to: 'executive', icon: BarChart3, label: 'Аналитика руководителя' },
]

// Стратегия компании: показатели и оргдизайн — двумя группами вместо девяти
// отдельных пунктов в двух секциях.
export const NAV_CEO = [
    // Панель собственника — лендинг owner и ceo (#6316): цель, темп прибыли,
    // мост и драйверы. Видна по праву owner_panel.read (module_seed).
    { to: 'owner-panel', icon: Gauge, label: 'Панель собственника' },
    { to: 'ceo', icon: Layers, label: 'Стратегия и KPI' },
    // Senate Ops Dashboard — операционная картина обменника целиком (GMV,
    // маржа, P&L менеджеров, PII клиентов). Отдельный пункт первых лиц:
    // собственники, CEO, admin (2026-07-28).
    { to: 'senate-ops-dashboard', icon: TrendingUp, label: 'Senate Ops Dashboard' },
    { groupKey: 'biz-metrics' },  // Exchange · ОКМ · Планирование штата
    { groupKey: 'orgdesign' },    // Операционная модель · Норма управляемости · …
    // Песочница — расчётные эксперименты по живым данным. Внутри список
    // экспериментов: новый появляется сам, правка меню не нужна.
    { to: 'sandbox', icon: FlaskConical, label: 'Песочница' },
]

// Senate Partner CRM — отдельная секция «Партнёрка», чтобы партнёр-менеджеры
// не нуждались в фильтрации между бизнес-задачами CEO. Включает воронку,
// продукты, планы, аналитику. Старая «Партнёры (экосистема)» — другой модуль
// (recruiting agencies), живёт в NAV_HR.
// Порядок по приоритету ролевой работы: ВЕРХ — ежедневные рабочие столы
// (вход + 3 стола + операционные экраны), затем сепаратор «Справочники» —
// настройки/каталоги/админка, которые открывают реже. Ни один пункт не
// удалён (parity-гард: каждый `to` обязан быть в module_seed) — только
// переупорядочен. subLabel-сепаратор поддержан NavSection/NavItem.
// Дедуп навигации (2026-06 → 2026-07): рабочий стол (кокпит) и карточка партнёра
// поглотили per-partner функции; аналитика собрана в единый хаб
// partner-analytics-suite. Планёрка ОПП 14.07: убраны дубли рабочего стола —
// «План касаний» (partner-touch-plan), «Дела» (partner-tasks), «Журнал встреч»
// (partner-meetings): активности планируются/отмечаются на рабочем столе.
// Все убранные пункты остаются как роуты (deep-link) и переиспользуются
// вкладками хаба / кнопкой «Запланировать» на рабочем столе.
// Партнёрка: 14 пунктов → 5. Документы партнёрки влиты сюда же — отдельная
// секция «Документы» из двух строк была лишним заголовком.
export const NAV_PARTNERS = [
    { groupKey: 'partner-desk' },     // Мой стол · Я и команда · Команда
    { groupKey: 'partner-base' },     // База CRM · Дерево сети · Гео-лиды
    { groupKey: 'partner-insight' },  // Аналитика · Стратегия · ОКК
    { groupKey: 'partner-refs' },     // Продукты · Планы · SLA · Сегменты · Импорт
    { groupKey: 'partner-docs' },     // Маркетинговые · Договоры
]

// Онлайн-команда: 10 пунктов → 5.
export const NAV_ONLINE_MANAGER = [
    { to: 'manager-dashboard', icon: Activity, label: 'Мой дашборд' },
    { to: 'me/morning-debrief', icon: Sunrise, label: 'Вчерашний разбор' },
    // Зависшие заявки — руководительский экран онлайн-команды. Виден только
    // тем, у кого есть право `senate_ops.stale_orders.read` (см. module_seed);
    // линейный менеджер его в меню не увидит.
    { to: 'stale-orders', icon: AlarmClock, label: 'Зависшие заявки' },
    { groupKey: 'om-team' },       // Менеджеры · KPI-планы · Мои коллеги
    { groupKey: 'team-learning' }, // та же группа, что у руководителя отдела
    // PS2 Bot убран из кабинета линейного онлайн-менеджера (Наталья 2026-08-02):
    // управление ботом — работа старшего и админа, у линейного там только чтение
    // чужой служебной кухни. Доступ сохранён ролям из module_seed('ps2-bot').
    // Senate Ops Dashboard уехал в «Стратегию компании» (2026-07-28).
]

// Администрирование уехало под шестерёнку в топбаре
// (docs/specs/navigation-redesign-2026-07.md §5, состав — layout/SettingsMenu.jsx).
// В левом меню остаётся один пункт: «Поддержка · Пульт» — им администратор
// пользуется каждый день, это работа, а не настройка.
export const NAV_IT_ADMIN = [
    { to: 'support-board', icon: LifeBuoy, label: 'Поддержка · Пульт', moduleKey: 'support-board' },
    // Доска задач агента живёт в шестерёнке (прямое требование заказчика), но
    // ею пользуются каждый день — как «Поддержка · Пульт», поэтому дублируется
    // и в левом меню. Реестр ниже снимает дубль в Ctrl+K.
    { to: 'agent-tasks', icon: ListTodo, label: 'Задачи агента', moduleKey: 'agent-tasks' },
]

// ── Плоский реестр всех разделов — для CommandPalette и Pinned/Recent lookup ──
// Включает все пункты кроме subLabel-сепараторов. Дашборд включён с section='Рекрутинг'.
// Пункты-группы (`groupKey`) раскрываются в свои вкладки: поиск по Ctrl+K и
// «Недавние» продолжают находить «Отпуска» или «Ключи» по имени, хотя в левом
// меню они спрятаны под общий пункт.
export const ALL_NAV_REGISTRY = [
    ...NAV_RECRUITING.filter(i => !i.subLabel && !i.groupKey).map(i => ({ ...i, section: 'Рекрутинг' })),
    ...ALL_GROUP_TABS.map(t => ({ ...t, section: t.groupLabel })),
    ...NAV_PERSONAL.filter(i => !i.groupKey).map(i => ({ ...i, section: 'Личный кабинет' })),
    // Кабинет подрядчика — единственный пункт NAV_CONTRACTOR, которого нет в
    // NAV_PERSONAL; остальные (inbox/wiki) уже пришли выше и дублировать их в
    // Ctrl+K не нужно.
    { to: 'contractor-cabinet', icon: Briefcase, label: 'Мой кабинет', section: 'Личный кабинет' },
    ...NAV_HR.filter(i => !i.groupKey).map(i => ({ ...i, section: 'HR Управление' })),
    ...NAV_FINANCE.map(i => ({ ...i, section: 'Финансы' })),
    ...NAV_APPROVALS.map(i => ({ ...i, section: 'Согласования' })),
    ...NAV_DEPT_HEAD.filter(i => !i.groupKey).map(i => ({ ...i, section: 'Руководитель отдела' })),
    ...NAV_CEO.filter(i => !i.groupKey).map(i => ({ ...i, section: 'CEO' })),
    ...NAV_PARTNERS.filter(i => !i.groupKey).map(i => ({ ...i, section: 'Партнёрка' })),
    ...NAV_ONLINE_MANAGER.filter(i => !i.groupKey).map(i => ({ ...i, section: 'Онлайн-менеджер' })),
    ...NAV_IT_ADMIN.map(i => ({ ...i, section: 'IT / Администрирование' })),
    // Пункты шестерёнки: в левом меню их нет, но поиск по Ctrl+K обязан
    // находить «Feature Flags» или «Организации» по названию.
    ...SETTINGS_GROUPS
        .flatMap(g => g.items.map(i => ({ ...i, section: g.title })))
        // Пункт, который есть и в левом меню, уже пришёл выше — второй раз в
        // Ctrl+K он не нужен.
        .filter(i => !NAV_IT_ADMIN.some(n => n.to === i.to)),
]
